import { Injectable } from '@angular/core';
import { InventoryQueryParamsService } from 'src/app/models/interfaces/inventory-query-params-service';
import { InventoryGroup, InventoryGroupName } from 'src/app/models/results/inventory-group';
import { InventoryQueryParams } from 'src/app/models/results/inventory-query-params';
import { InventoryUserType } from 'src/app/models/results/inventory-user-type';
import { WizardOption } from 'src/app/models/wizard/wizard-option';
import { ConfigService } from '../../config/config.service';


@Injectable({
  providedIn: 'root'
})
export class EducationInventoryQueryParamsService implements InventoryQueryParamsService {

  constructor(private confSvc: ConfigService) { }

  setFields(queryParams: InventoryQueryParams, needToRunOptions: WizardOption[], useCaseOption: WizardOption, brandOptions: WizardOption[]): void {
    this.setUserType(queryParams, useCaseOption);
    this.setGroups(queryParams, needToRunOptions);
    this.setBrands(queryParams, brandOptions);
  }

  private setUserType(queryParams: InventoryQueryParams, useCaseOption: WizardOption): void {
    switch(useCaseOption.title) {
      case this.confSvc.getString("useCaseGradeSchoolTitle"):
        queryParams.userType = Object.assign(new InventoryUserType(), {
          name: this.confSvc.getString("useCaseGradeSchoolTitle"),
          allowedFormFactors: [],
        });
        break;
      case this.confSvc.getString("useCaseHighSchoolCollegeTitle"):
        queryParams.userType = Object.assign(new InventoryUserType(), {
          name: this.confSvc.getString("useCaseHighSchoolCollegeTitle"),
          allowedFormFactors: [],
        });
        break;
      case this.confSvc.getString("useCaseTeachersStaffTitle"):
        queryParams.userType = Object.assign(new InventoryUserType(), {
          name: this.confSvc.getString("useCaseTeachersStaffTitle"),
          allowedFormFactors: [],
        });
        break;
      default:
        break;
    }
  }

  private setGroups(queryParams: InventoryQueryParams, needToRunOptions: WizardOption[]): void {
    const needToRunOptionTitles = needToRunOptions.map(option => option.title);

    const groups = this.getGroups();

    groups.forEach(group => {
      if (this.needToRunOptionForGroupWasSelected(group, needToRunOptionTitles)) {
        queryParams.groups.push(group);
      }
    });

    this.sortGroupsByPriority(queryParams);
  }

  public getGroups(): InventoryGroup[] {
    return [
      Object.assign(new InventoryGroup(), {
        name: InventoryGroupName.LearningAnywhere,
        minimumRAM: this.confSvc.getNum("learningAnywhereMinRAM"),
        allowedCPUs: [
          this.confSvc.getString("intelCeleronN4000"),
          this.confSvc.getString("amdA4"),
          this.confSvc.getString("amdA6"),
          this.confSvc.getString("amd3015Ce"),
          this.confSvc.getString("amdRyzen"),
          this.confSvc.getString("intelCeleronN4020"),
          this.confSvc.getString("intelCeleronN4100"),
          this.confSvc.getString("intelCeleronN4120"),
          this.confSvc.getString("intelCeleronN5100"),
          this.confSvc.getString("intelPentiumN6000"),
          this.confSvc.getString("inteli3"),
          this.confSvc.getString("inteli5"),
          this.confSvc.getString("inteli7"),
          this.confSvc.getString("mediaTekMT8183"),
          this.confSvc.getString("qualcomm7c")
        ],
        priority: this.confSvc.getNum("learningAnywherePriority"),
        needToRunOptions: [
          this.confSvc.getString("needToRunSimpleTitleEdu"),
        ],
        userTypeNames: [
          this.confSvc.getString("useCaseGradeSchoolTitle"),
          this.confSvc.getString("useCaseHighSchoolCollegeTitle"),
          this.confSvc.getString("useCaseTeachersStaffTitle")
        ]
      }),
      Object.assign(new InventoryGroup(), {
        name: InventoryGroupName.AdvancedUse,
        minimumRAM: this.confSvc.getNum("advancedClassroomUseMinRAM"),
        allowedCPUs: [
          this.confSvc.getString("inteli3"),
          this.confSvc.getString("inteli5"),
          this.confSvc.getString("inteli7"),
          this.confSvc.getString("amdRyzen")
        ],
        priority: this.confSvc.getNum("advancedClassroomUsePriority"),
        needToRunOptions: [
          this.confSvc.getString("needToRunAdvancedTitleEdu"),
        ],
        userTypeNames: [
          this.confSvc.getString("useCaseGradeSchoolTitle"),
          this.confSvc.getString("useCaseHighSchoolCollegeTitle"),
          this.confSvc.getString("useCaseTeachersStaffTitle")
        ]
      })
    ];
  }

  private needToRunOptionForGroupWasSelected(group: InventoryGroup, selectedNeedToRunOptionTitles: string[]): boolean {
    return group.needToRunOptions.some(option => selectedNeedToRunOptionTitles.includes(option));
  }

  private sortGroupsByPriority(queryParams: InventoryQueryParams): void {
    queryParams.groups.sort((a, b) => (a.priority < b.priority) ? 1 : -1);
  }

  private setBrands(queryParams: InventoryQueryParams, brandOptions: WizardOption[]): void {
    if (brandOptions.length && (brandOptions[0].title !== this.confSvc.getString("brandNoPreferenceOptionTitle"))) {
      queryParams.brands = brandOptions.map(option => this.getDataSetBrandName(option.title));
    }
  }

  private getDataSetBrandName(displayBrandName: string): string {
    return this.confSvc.getRelatedFieldFromConfig(displayBrandName, "Display", "DataSource");
  }
}
